import { useStore } from '@nanostores/react';
import { billing } from '@/services/billing';
import { getCurrentPlan } from '../utils/current-plan-label';

export function useCurrentPlanLabel(): string {
  const isPremiumTrial = useStore(billing.isPremiumTrial);
  const isTrial = useStore(billing.isTrial);
  const isSubscriptionActive = useStore(billing.isSubscriptionActive);
  const planType = useStore(billing.planType);

  return getCurrentPlan(isPremiumTrial, isTrial, isSubscriptionActive, planType);
}
